import { useMemo, type ReactNode } from 'react';
import {
  useReadersCatalogTableFilters,
  type ReadersCatalogTableFiltersContextValue,
} from '@/hooks/useReadersCatalogTableFilters';
import { createStrictTableFiltersContext } from '@/contexts/createStrictTableFiltersContext';

export type ReadersCatalogFiltersContextValue = ReadersCatalogTableFiltersContextValue;

const [ReadersCatalogFiltersContext, useReadersCatalogFiltersContext] =
  createStrictTableFiltersContext<ReadersCatalogFiltersContextValue>('useReadersCatalogFilters');

export const useReadersCatalogFilters = useReadersCatalogFiltersContext;

export function ReadersCatalogFiltersProvider({ children }: { children: ReactNode }) {
  const tableFilters = useReadersCatalogTableFilters();

  const value = useMemo(
    (): ReadersCatalogFiltersContextValue => ({
      filtersEnabled: tableFilters.filtersEnabled,
      toggleFiltersEnabled: tableFilters.toggleFiltersEnabled,
      setFiltersEnabled: tableFilters.setFiltersEnabled,
      filters: tableFilters.filters,
      setFilter: tableFilters.setFilter,
      replaceFilters: tableFilters.replaceFilters,
      clearAllFilters: tableFilters.clearAllFilters,
      activeFilterCount: tableFilters.activeFilterCount,
      filterItems: tableFilters.filterItems,
      filterReaders: tableFilters.filterReaders,
    }),
    [tableFilters]
  );

  return (
    <ReadersCatalogFiltersContext.Provider value={value}>{children}</ReadersCatalogFiltersContext.Provider>
  );
}
